/**
 * Created by Fernando Torres on 01/02/2018.
 */

import EvaluationsListView from '@/views/app/evaluations/evaluations-list.view'

export default [{
  path: 'evaluations',
  name: 'evaluations',
  component: EvaluationsListView
}]



// WEBPACK FOOTER //
// ./src/router/app/evaluations/index.js